import { defineMessage } from 'react-intl';

/**
 *  Only a few of the descriptions have been filled in.
 *  This is because the translations migrated over from another translation system, and we essentially used the desc
 *  as a key to map the translations
 */
export const pptMessages = {
    header: {
        attackZonePercent: defineMessage({
            defaultMessage: 'Attack Zone %',
            description: 'ppt.attackZonePercent',
        }),
        distance: defineMessage({
            defaultMessage: 'Total Distance',
            description: 'ppt.distance',
        }),
        distancePerShift: defineMessage({
            defaultMessage: 'Distance / Shift',
            description: 'Total distance a skaters skates on the ice per shift',
        }),
        player: defineMessage({
            defaultMessage: 'Player',
            description: 'ppt.player',
        }),
        speedAvg: defineMessage({
            defaultMessage: 'Avg Speed',
            description: 'ppt.speedAvg',
        }),
        speedMax: defineMessage({
            defaultMessage: 'Max Speed',
            description: 'ppt.speedMax',
        }),
    },
    measurement: {
        'distancePerShift.imp': defineMessage({
            defaultMessage: 'FT',
            description: 'ppt.distancePerShift.imp',
        }),
        'distancePerShift.met': defineMessage({
            defaultMessage: 'M',
            description: 'ppt.distancePerShift.met',
        }),
        'velocity.imp': defineMessage({
            defaultMessage: 'MPH',
            description: 'ppt.velocity.imp',
        }),
        'velocity.met': defineMessage({
            defaultMessage: 'KPH',
            description: 'ppt.velocity.met',
        }),
        'distance.imp': defineMessage({
            defaultMessage: 'MI',
            description: 'ppt.distance.imp',
        }),
        'distance.met': defineMessage({
            defaultMessage: 'KM',
            description: 'ppt.distance.met',
        }),
    },
    title: {
        attackZonePercent: defineMessage({
            defaultMessage: 'Player Based',
            description: 'title.ppt.attackZonePercent',
        }),
    },
    tooltips: {
        attackZonePercent: defineMessage({
            defaultMessage:
                "% of player's TOI spent in the offensive zone vs. defensive zone, all situations. TOI in neutral zone ignored",
            description: 'tooltips.ppt.attackZonePercent',
        }),
        distance: defineMessage({
            defaultMessage: 'Total distance skated',
            description: 'Total distance a skaters skates on the ice',
        }),
        distancePerShift: defineMessage({
            defaultMessage: 'Total distance skated/shifts',
            description: 'Total distance a skaters skates on the ice per shift',
        }),
        player: defineMessage({
            defaultMessage: 'Player Name',
            description: 'tooltips.ppt.player',
        }),
        speedAvg: defineMessage({
            defaultMessage: 'Average skating speed',
            description: 'tooltips.ppt.speedAvg',
        }),
        speedMax: defineMessage({
            defaultMessage: 'Maximum skating speed',
            description: 'tooltips.ppt.speedMax',
        }),
    },
};
